import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=8a1b85ec&"
import script from "./horizontal-nav.vue?vue&type=script&lang=js&"
export * from "./horizontal-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a1b85ec')) {
      api.createRecord('8a1b85ec', component.options)
    } else {
      api.reload('8a1b85ec', component.options)
    }
    module.hot.accept("./horizontal-nav.vue?vue&type=template&id=8a1b85ec&", function () {
      api.rerender('8a1b85ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/horizontal-nav.vue"
export default component.exports